import React, {useState} from 'react';
import DatePickerComp from "react-datepicker";
import TextInput from "../TextInput";
import ArrowLeftSingleIcon from "../../assets/svgs/arrow-left-single.svg";
import ArrowLeftDoubleIcon from "../../assets/svgs/arrow-left-double.svg";
import ArrowRightSingleIcon from "../../assets/svgs/arrow-right-single.svg";
import ArrowRightDoubleIcon from "../../assets/svgs/arrow-right-double.svg";

import './datePicker.scss';
import './reactDatePicker.scss';

import ButtonBase from "../ButtonBase";
import Text from "../Text";
import PropTypes from "prop-types";

const CustomHeader = (isTwoMonths) => ({
                                         monthDate, decreaseMonth,
                                         increaseMonth,
                                         prevMonthButtonDisabled,
                                         nextMonthButtonDisabled,
                                         customHeaderCount,
                                         decreaseYear,
                                         nextYearButtonDisabled,
                                         prevYearButtonDisabled,
                                         increaseYear,
                                       }) => {
  const dateText = monthDate.toLocaleDateString('en-US', {year: 'numeric', month: 'long'})
  return <div className={`Suc-calendar-custom-header ${customHeaderCount === 1 ? 'Suc-multiple-months' : ''}`}>
    <div className="Suc-actions-before">
      {customHeaderCount === 0 && <>
        <ButtonBase type="button" onClick={(e) => {
          decreaseYear();
        }} disabled={prevYearButtonDisabled}>
          <ArrowLeftDoubleIcon/>
        </ButtonBase>
        <ButtonBase type="button" onClick={(e) => {
          decreaseMonth();
          decreaseMonth();
        }} disabled={prevMonthButtonDisabled}>
          <ArrowLeftSingleIcon/>
        </ButtonBase>
      </>}
    </div>
    <Text fontWeight={600} className="Suc-date-text">
      {dateText}
    </Text>
    <div className="Suc-actions-after">
      {(customHeaderCount === 1 || !isTwoMonths) && <>
        <ButtonBase type="button" onClick={(e) => {
          increaseMonth()
          increaseMonth()
        }} disabled={nextMonthButtonDisabled}>
          <ArrowRightSingleIcon/>
        </ButtonBase>
        <ButtonBase type="button" onClick={(e) => {
          increaseYear()
        }} disabled={nextYearButtonDisabled}>
          <ArrowRightDoubleIcon/>
        </ButtonBase>
      </>}
    </div>
  </div>
}

const DateTextInput = ({isCalendarOpen, ...props}) => <div>
  <TextInput removeBottomMargin={true} {...props} />
  <div className={`Suc-drop-down-indicator ${isCalendarOpen ? 'Suc-open' : ''}`}/>
</div>

/** Date Picker and date range - see props at https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md  */
const DatePicker = ({textFieldProps, ...props}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  return <div className={'Suc-date-picker'}>
    <DatePickerComp
      customInput={<DateTextInput isCalendarOpen={isCalendarOpen} {...textFieldProps} />}
      renderCustomHeader={CustomHeader(props.monthsShown > 1)}
      disabledKeyboardNavigation={true}
      wrapperClassName={'Suc-date-input'}
      clearButtonClassName={'Suc-clear-button'}
      onCalendarClose={() => setIsCalendarOpen(false)}
      onCalendarOpen={() => setIsCalendarOpen(true)}
      {...props}>
    </DatePickerComp>
  </div>
}

DatePicker.propTypes = {
  /** custom props to the text field */
  textFieldProps: PropTypes.object,
}

DatePicker.defaultProps = {
  textFieldProps: {},
}
export default DatePicker;
